export class UndoStatusRequestEntry {

  constructor(public eventId: number,
              public objectId: number,
              public comment: string,
              public actionType: string,
              public eventStatus: string) {
  }

}
